import React from 'react';

import appConfig from '@/config/appConfig.typed';
import {twx} from '@/utils/tailwindUtils';
import urlUtils from '@/utils/urlUtils';

import useBestImageMedia from './useBestImageMedia';

const RemoteImageWithBackground = ({imageMedia, className, imgClassName, backgroundClassName}) => {
    const best = useBestImageMedia(imageMedia);

    if (!best?.path) return null;

    const {path, alt, background} = best;

    const imageSrc = urlUtils.join(appConfig.getContentPath(), path);
    const backgroundStyle = background ? {background} : undefined;

    return (
        <div className={twx('absolute isolate', className)}>
            <img className={twx('absolute left-0 top-0 h-full w-full', imgClassName)} src={imageSrc} alt={alt} />
            {backgroundStyle && (
                <div
                    className={twx('absolute left-0 top-0 z-10 h-full w-full', backgroundClassName)}
                    style={backgroundStyle}
                />
            )}
        </div>
    );
};

export default RemoteImageWithBackground;
